import React from "react";
import { getBehaviourColourForPosition } from "@signolteam/shared/colours";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import _ from "lodash";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

/** A chart of one column per period, with a box/pill per behaviour above it
 * @param {{
 *   industry: string;
 *   customerBehaviours: Array<{behaviourAcronym: string, behaviourName: string, order: number}>
 *   operatorPeriodImpact: Array<{ behaviourGroupCode: string, behaviourGroupId: string, donationTotal: number, goalTargetAchievedOperator: boolean, periodKey: string, sumSavingsKg: number }>,
 * }} props
 */
const PersonalPeriodDonationTable = ({
  currentYear = null,
  industry,
  customerBehaviours,
  operatorPeriodImpact,
}) => {
  const bvrAcronymToOrder = customerBehaviours?.reduce((acc, obj) => {
    acc[obj.behaviourAcronym] = obj.order;
    return acc;
  }, {});
  const grouped = _.chain(operatorPeriodImpact)
    .filter((d) => currentYear == null || d.periodKey.startsWith(currentYear))
    .map((b) => ({
      ...b,
      //TODO: TEMP Add order property to each item
      order: bvrAcronymToOrder[b.behaviourGroupCode],
    }))
    .sortBy("order")
    .reduce((acc, item) => {
      acc[item.periodKey] ??= {};
      acc[item.periodKey][item.behaviourGroupCode] = item;
      return acc;
    }, {})
    .value();

  const formatPeriodDate =
    industry === "shipping"
      ? (s) =>
          new Intl.DateTimeFormat("en-GB", {
            day: "numeric",
            month: "short",
          }).format(new Date(s))
      : (s) =>
          new Intl.DateTimeFormat("en-GB", { month: "short" }).format(
            new Date(s + "-01"),
          );

  return (
    <div className="h-full grid grid-flow-col gap-4 overflow-y-auto">
      {Object.entries(grouped).map(([period, groups]) => (
        <div key={period} className="text-sm flex flex-col-reverse">
          <div className="my-3 whitespace-nowrap">
            {formatPeriodDate(period)}
          </div>
          {_(groups)
            .sortBy("order")
            .reverse()
            .entries()
            .map(([order, item]) => {
              return (
                <div
                  key={order}
                  className={`h-5 my-px text-center text-transparent
                  ${item.donationTotal > 0 ? `bg-${getBehaviourColourForPosition(item.order).name}-500 hover:text-white` : "bg-neutral-300 hover:text-neutral-600"}
                `}
                >
                  <small className="tracking-tight">
                    {item.behaviourGroupCode}
                  </small>
                </div>
              );
            })
            .value()}
        </div>
      ))}
    </div>
  );
};

export const personalPeriodDonationTableControls = {
  industry: COMMON_CONTROLS.industry,
  operatorPeriodImpact: {
    propType: PropTypes.object.isRequired,
    description: "per-period impact data",
    disable: true,
  },
  customerBehaviours: {
    propType: PropTypes.array.isRequired,
    description: "Customer Behaviour Type data",
    disable: true,
  },
};

PersonalPeriodDonationTable.propTypes = AppUtils.getPropTypeFromControls(
  personalPeriodDonationTableControls,
);
export default PersonalPeriodDonationTable;
